var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trailerNameLabel",class:{
    eligibleForDetention: _vm.eligibleForDetention,
    inDetention: _vm.inDetention,
  },attrs:{"title":_vm.titleDisplay}},[(_vm.showInbound)?_c('span',[_vm._v("[ I ]")]):_vm._e(),(_vm.showOutbound)?_c('span',[_vm._v("[O]")]):_vm._e(),_vm._v(" "+_vm._s(_vm.trailer.id)+" "),_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTagged),expression:"isTagged"}],class:{ redTag: _vm.trailer.redTag, yellowTag: _vm.trailer.yellowTag },attrs:{"icon":"tag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }